// ======================================================================
// File Name       : ServiceGroupRegisterEditContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as serviceGroupActions from '../../actions/ServiceGroupAction';
import * as modalActions from '../../actions/ModalAction';
import ModalWrapper from '../../components/modal/ModalWrapper';
import ServiceGroupRegisterEdit from '../../components/serviceGroup/ServiceGroupRegisterEdit';
import { MODE } from '../../constants';
import { REDIRECT_MODAL } from '../../constants/ServiceGroupConstants';
import ModalConductor from '../../components/modal/ModalConductor';

class ServiceGroupRegisterEditContainer extends Component {
  constructor() {
    super();
    this.state = {
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleNextBtn = this.handleNextBtn.bind(this);
    this.validation = this.validation.bind(this);
    this.hideModal = this.hideModal.bind(this);
  }

  handleInputChange(name, value) {
    const { dispatch } = this.props;
    dispatch(serviceGroupActions.editingServiceGroup({ [name]: value }));
  }

  handleNextBtn() {
    if (!this.validation()) return;
    const { dispatch, modalId } = this.props;
    dispatch(modalActions.openModal(REDIRECT_MODAL[modalId].OK));
  }

  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  getModalOptions() {
    const { serviceGroup } = this.props;
    const footerBtns = [
      { name: 'キャンセル', onClick: this.props.hideModal, variant: 'default' },
      { name: '次へ', onClick: this.handleNextBtn, variant: 'primary' },
    ];
    const OPTIONS = {
      [MODE.NEW_MODE]: {
        title: 'サービスグループ情報の新規登録',
        footerBtns,
      },
      [MODE.EDIT_MODE]: {
        title: 'サービスグループ情報の編集',
        footerBtns,
      },
    };
    return OPTIONS[serviceGroup.editType];
  }

  hideModal() {
    this.props.hideModal();
  }

  render() {
    const { serviceGroup } = this.props;
    this.refsToValidate = [];
    return (
      <ModalWrapper
        {...this.getModalOptions()}
        hideModal={this.hideModal}
        dialogClassName="group-detail-dialog"
      >
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            this.handleNextBtn();
          }}
          className='form-horizontal'
        >
          <ServiceGroupRegisterEdit
            editingServiceGroup={serviceGroup.editingServiceGroup}
            handleInputChange={this.handleInputChange}
            ref={(groupRegistEdit) => {
              if (groupRegistEdit) {
                this.refsToValidate.push(groupRegistEdit);
              }
            }}
          />
        </Form>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { serviceGroup } = state;
  return { serviceGroup };
};
export default connect(mapStateToProps)(ServiceGroupRegisterEditContainer);
